import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map, Observable} from "rxjs";
import {
  BulkCreationReport,
  BulkImportLine,
  BulkSearchResponse
} from "../ouvrage/bulk-create-ouvrage/bulk-ouvrage.model";

@Injectable({
  providedIn: 'root'
})
export class OuvrageService {

  constructor(private http: HttpClient) {
  }

  createOuvrage(id, CodeProjet, OuvrageReforme): Observable<Object> {

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${environment.apiUrl}/api/ouvrage/create`, {id: id, CodeProjet: CodeProjet, OuvrageReforme: OuvrageReforme}).pipe(
      map(response => {

        return response;
      })
    );
  }

  updateOuvrage(id, CodeProjet, OuvrageReforme): Observable<Object> {

    return this.http.post(`${environment.apiUrl}/api/ouvrage/update`, {id: id, CodeProjet: CodeProjet, OuvrageReforme: OuvrageReforme}).pipe(
      map(response => {

        return response;
      })
    );
  }

  /** Phase 2 du flux "Créer des projets en lot" (SUPER_CEM) : résout EAN -> BaseArticle/Ouvrage sans rien créer. */
  searchBaseArticlesByEans(lines: BulkImportLine[]): Observable<BulkSearchResponse> {
    return this.http.post<BulkSearchResponse>(`${environment.apiUrl}/api/base_article/search_by_eans`, {lines});
  }

  /** Phase 3 du flux "Créer des projets en lot" (SUPER_CEM) : création partielle des lignes valides. */
  createOuvragesBulk(items: Array<BulkImportLine & { ouvrageReforme: boolean }>): Observable<BulkCreationReport> {
    return this.http.post<BulkCreationReport>(`${environment.apiUrl}/api/ouvrage/create_bulk`, {items});
  }

  exportOuvrage(id): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/ouvrage/export_complet`, {idOuvrage:id},{responseType: 'blob', observe: "response"}).pipe(
      map(response => {
        return response;
      })
    );
  }

}
